export default __webpack_public_path__ + "static/media/Expenditure.6160dd7b.png";